var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLcAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1111_354)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1111_354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2157 30.7363C20.2965 30.7363 18.9257 32.1697 18.9257 34.1112C18.8996 35.0755 19.226 35.9355 19.8396 36.5609C20.4401 37.1734 21.2888 37.5122 22.2157 37.5122C24.1349 37.5122 25.5449 36.0788 25.5449 34.1112C25.5058 32.1306 24.1349 30.7363 22.2157 30.7363ZM22.2157 35.8834C21.7196 35.8834 21.3018 35.714 21.0146 35.4273C20.7143 35.1146 20.5576 34.6585 20.5707 34.1373C20.5707 33.0688 21.2104 32.3782 22.2157 32.3782C23.221 32.3782 23.8738 33.0427 23.8999 34.1373C23.8999 35.1927 23.2471 35.8834 22.2157 35.8834Z",
    fill: "#243D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0566 14.1356C23.0382 13.0932 21.3932 13.0932 20.3879 14.1356C19.6959 14.8392 19.3304 15.9208 19.3696 17.0674L19.6307 23.7521L19.6568 24.4818L19.7482 26.6318C19.8265 28.7297 20.884 30.3064 22.2288 30.3064C23.5735 30.3064 24.618 28.7297 24.6963 26.6318L25.0749 17.0674C25.1141 15.9208 24.7485 14.8523 24.0566 14.1356ZM23.0513 26.5536C23.0121 27.9088 22.4115 28.6645 22.2157 28.6645C22.0199 28.6645 21.4193 27.9088 21.3671 26.5536L21.0015 16.9893C20.9624 16.2986 21.1712 15.6601 21.5629 15.2692C21.6935 15.1259 21.9285 14.9565 22.2157 14.9565C22.4507 14.9565 22.6727 15.0607 22.8685 15.2692C23.2341 15.6471 23.4429 16.3117 23.4299 16.9893L23.0513 26.5536Z",
    fill: "#243D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7316 36.9257L25.323 6.98176C24.5396 5.70477 23.456 5.01416 22.2418 5.01416C21.0276 5.01416 19.9179 5.74386 19.1345 7.00782L12.2803 18.1358C11.993 18.6049 12.1367 19.2304 12.6067 19.5301C12.8417 19.6734 13.1158 19.7255 13.377 19.6604C13.6511 19.5952 13.8731 19.4389 14.0167 19.2043L20.884 8.07631C21.2887 7.42479 21.7849 7.04691 22.2549 7.04691C22.7249 7.04691 23.2079 7.41176 23.5996 8.05025L42.0082 37.9942C42.3738 38.6066 42.4913 39.1409 42.3215 39.4536C42.1257 39.7794 41.5774 39.9748 40.8332 39.9748H3.63737C2.90625 39.9748 2.34485 39.7794 2.16207 39.4536C1.99235 39.1279 2.10985 38.5806 2.47541 37.9812L11.5492 23.8562C11.8364 23.3871 11.6928 22.7616 11.2228 22.4619C10.9878 22.3186 10.7136 22.2665 10.4525 22.3316C10.1783 22.3968 9.95635 22.5531 9.81274 22.7877L0.738997 36.9127C-0.0443473 38.2027 -0.161849 39.4536 0.399548 40.4439C0.960945 41.4473 2.10985 42.0076 3.63737 42.0076H40.8332C42.3607 42.0076 43.5096 41.4473 44.071 40.4439C44.293 40.0661 44.4105 39.597 44.4105 39.1148C44.4105 38.4112 44.1755 37.6815 43.7185 36.9387L43.7316 36.9257Z",
    fill: "#243D63"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1111_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.3765,
    height: 44.3765,
    fill: "white",
    transform: "translate(0.0470581 0.576416)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1111_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.3765,
    height: 36.9804,
    fill: "white",
    transform: "translate(0.0470581 5.01416)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcAlertIcon);
export default __webpack_public_path__ + "static/media/LCAlertIcon.2a1a0a3d9cec83e0596f413dfc50f667.svg";
export { ForwardRef as ReactComponent };